<div class="overlay-inner-wrapper">
  <div id="abnahmeProtokollWrapper">
    <div class="clr-row nxm">
      <div class="clr-col-12">
        <div class="text-left inline-block">
          <h3 class="mt-0">{{ 'Abnahme nach Umbau' | mrTranslate }} - {{ titel }}</h3>
        </div>
        <div class="inline-block" style="float: right">
          <cds-icon size="20" shape="times" (click)="close()" class="cursor-pointer" />
        </div>
      </div>
    </div>
    <div class="clr-col-12 clr-row nxm" style="height: calc(100% - 1.2rem)">
      <div class="clr-col-12 clr-col-lg-7">
        <!-- style="width: 100%;" -->
        <form class="width100" clrForm [formGroup]="store.form" (ngSubmit)="submit()">
          <div class="clr-row nxm margin-24-t">
            <label for="objekte" class="clr-col-12 clr-col-md-4 clr-control-label">
              {{ 'Objekte' | mrTranslate }}
            </label>
            <div class="clr-col-12 clr-col-md-8 clr-row wrapdiv">
              @for (objekt of store.objekts(); track objekt['ostammid']) {
                <div>
                  @let shape = `objekttyp${objekt['typ']}`;
                  <cds-icon style="fill: black" class="margin-18-l margin-6-r grid-icon" [shape]="shape" size="28" />
                  <span>{{ objekt['Bezeichnung'] }}</span>
                </div>
              }
            </div>
          </div>
          <clr-input-container>
            <label class="clr-col-12 clr-col-md-4">
              {{ 'Auftragsnummer' | mrTranslate }}
            </label>
            <input
              class="clr-col-12 clr-col-md-8"
              clrInput
              name="auftragId"
              [value]="store.auftragId() | leftPadd: 5"
              readonly />
          </clr-input-container>
          <clr-input-container>
            <label class="clr-col-12 clr-col-md-4">
              {{ 'Auftragnehmer' | mrTranslate }}
            </label>
            <input class="clr-col-12 clr-col-md-8" clrInput name="auftragnehmer" [value]="auftragnehmer" readonly />
          </clr-input-container>
          <clr-input-container>
            <label class="clr-col-12 clr-col-md-4" for="pruefer">
              {{ 'Prüfer' | mrTranslate }}
            </label>
            <input class="clr-col-12 clr-col-md-8" clrInput formControlName="Pruefer" readonly />
          </clr-input-container>
          @if (store.isNew()) {
            <clr-date-container>
              <label class="clr-required-mark clr-col-12 clr-col-md-4" for="datum">
                {{ 'Datum' | mrTranslate }}
              </label>
              <input
                class="clr-col-12 clr-col-md-8"
                type="date"
                clrDate
                name="datum"
                [ngModel]="store.form.value.Datum | localeDate"
                (ngModelChange)="store.setDatum(localeDate.toBackEndFormat($event))"
                [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                required />
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Datum muss eingegeben werden' | mrTranslate }}
              </clr-control-error>
            </clr-date-container>
          } @else {
            <clr-input-container>
              <label class="clr-col-12 clr-col-md-4" for="datum">
                {{ 'Datum' | mrTranslate }}
              </label>
              <input
                class="clr-col-12 clr-col-md-8"
                clrInput
                name="datum"
                [value]="store.form.value.Datum | localeDate"
                readonly />
            </clr-input-container>
          }
          <div class="padding-30-tb">
            <hr />
            <label class="clr-col-12 clr-control-label">{{ 'geprüft wurden' | mrTranslate }}:</label>
            <div class="clr-row padding-10-t clr-col-12">
              @for (check of geprueftChecks; track check.field) {
                <clr-checkbox-wrapper class="clr-col-12 clr-col-md-6">
                  <input type="checkbox" clrCheckbox [formControlName]="check.field" />
                  <label>{{ check.label | mrTranslate }}</label>
                </clr-checkbox-wrapper>
              }
            </div>
          </div>
          <div class="padding-30-tb">
            <hr />
            <label class="clr-col-12 clr-control-label">
              {{
                'Die Anlage(n) wurde sachgemäß geprüft und ggf. nach einer Belastungsprobe (Probefahrt)' | mrTranslate
              }}:
            </label>
            <div class="clr-row padding-10-t">
              <div class="clr-col-12">
                @for (check of genommenChecks; track check.field) {
                  <clr-checkbox-wrapper class="clr-col-12 clr-col-md-6">
                    <input type="checkbox" clrCheckbox [formControlName]="check.field" />
                    <label>{{ check.label | mrTranslate }}</label>
                  </clr-checkbox-wrapper>
                }
              </div>
            </div>
          </div>
          <div class="padding-0-tb">
            <clr-textarea-container>
              <label class="clr-col-4">
                {{ 'Bemerkung' | mrTranslate }}
              </label>
              <textarea class="clr-col-8" clrTextarea formControlName="Bemerkung"></textarea>
            </clr-textarea-container>
          </div>
          <div class="padding-0-tb">
            <clr-textarea-container class="margin-1-r">
              <label class="clr-required-mark clr-col-12 clr-col-md-4 clr-align-self-center nowrap">
                {{ 'Freigegeben an' | mrTranslate }}
              </label>
              <textarea
                rows="1"
                class="clr-col-12 clr-col-md-8"
                style="width: 100%"
                clrTextarea
                formControlName="Freigabe"></textarea>
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
            </clr-textarea-container>
          </div>
          <!-- ? Toggle ja / nein ? -->
          <div class="padding-30-tb margin-1-r">
            <hr />
            <div class="clr-row">
              <label class="clr-col-12 clr-col-md-4 clr-control-label">
                {{ 'Mängel festgestellt' | mrTranslate }}:
              </label>
              <div class="clr-col clr-control-inline" style="justify-content: flex-end">
                <clr-radio-wrapper>
                  <input type="radio" clrRadio [value]="true" formControlName="IsNeuMangel" />
                  <label>{{ 'ja' | mrTranslate }}</label>
                </clr-radio-wrapper>
                <clr-radio-wrapper>
                  <input type="radio" clrRadio [value]="false" formControlName="IsNeuMangel" />
                  <label>{{ 'nein' | mrTranslate }}</label>
                </clr-radio-wrapper>
              </div>
            </div>
            <!-- opens if Neue Mängel = ja -->
            @if (store.form.value.IsNeuMangel) {
              <div class="padding-10-t">
                <label class="clr-col-12">
                  {{ 'geringfügige Mängel die vom Auftragnehmer umgehend zu beseitigen sind' | mrTranslate }}:
                </label>
                <div class="clr-row padding-24-l" style="align-items: baseline">
                  <div class="clr-col-9 clr-row nxm" style="align-items: baseline">
                    <div class="clr-col-2">
                      @let shape = store.selectedObjekt() | get: getSelectedObjektIcon;
                      <cds-icon style="fill: black" class="margin-6-tb grid-icon" [shape]="shape" size="36" />
                    </div>
                    <div class="clr-col-10">
                      <clr-select-container>
                        <label class="clr-col-4">{{ 'Objekt' | mrTranslate }}</label>
                        <select
                          class="clr-col-8"
                          clrSelect
                          [ngModel]="store.selectedObjekt()"
                          (ngModelChange)="store.setSelected($event)"
                          [ngModelOptions]="{ standalone: true }">
                          @for (objekt of store.objekts(); track objekt['ostammid']) {
                            <option [ngValue]="objekt">{{ objekt['Bezeichnung'] }}</option>
                          }
                        </select>
                      </clr-select-container>
                    </div>
                  </div>
                  <div class="clr-col-3" style="text-align: center">
                    <button
                      type="button"
                      class="btn btn-icon btn-info-outline"
                      aria-label="add"
                      (click)="addNeuMangel()">
                      <cds-icon shape="plus-circle" />
                    </button>
                  </div>
                </div>
                <div class="clr-row">
                  <div class="clr-col mw-100-p">
                    @let maengel = store.mangelTable();
                    @if (maengel.rows.length) {
                      <clr-datagrid class="datagrid-compact">
                        @for (column of maengel.columns; track column.id) {
                          <clr-dg-column>
                            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                              {{ column.id | mrTranslate }}
                            </ng-container>
                          </clr-dg-column>
                        }

                        <clr-dg-row *clrDgItems="let row of maengel.rows">
                          <clr-dg-action-overflow>
                            <button class="action-item" (click)="deleteMangel(row)">
                              {{ 'Mangel löschen' | mrTranslate }}
                            </button>
                          </clr-dg-action-overflow>
                          @for (cell of maengel.columns; track cell.id) {
                            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint: cell.id }}</clr-dg-cell>
                          }
                        </clr-dg-row>

                        <clr-dg-footer>{{ maengel.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                      </clr-datagrid>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          <!-- ^ opens if Neue Mängel = ja ^ -->
          <div class="padding-30-tb margin-1-r">
            <hr />
            <div class="clr-row">
              <clr-radio-container class="clr-col-12">
                <label class="clr-required-mark clr-col-6 margin-36-b">
                  {{ 'Die Abnahme nach Umbau gilt als' | mrTranslate }}:
                </label>
                <clr-radio-wrapper style="justify-self: flex-end">
                  <label>{{ 'erteilt' | mrTranslate }}</label>
                  <input type="radio" clrRadio [value]="true" formControlName="IsErteilt" />
                </clr-radio-wrapper>
                <clr-radio-wrapper style="justify-self: flex-end">
                  <input type="radio" clrRadio [value]="false" formControlName="IsErteilt" />
                  <label>{{ 'nicht erteilt' | mrTranslate }}</label>
                </clr-radio-wrapper>
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-radio-container>
            </div>
          </div>
          <div class="padding-30-tb margin-1-r signatures">
            <hr />
            <div class="clr-row padding-30-tb">
              <div class="clr-col-12 clr-col-md-12 padding-24-l hideIfSmall">
                <button
                  [disabled]="isZoomedIn()"
                  type="button"
                  class="btn btn-icon btn-info-outline"
                  aria-label="resize"
                  (click)="isZoomedIn.set(true)">
                  <cds-icon shape="zoom-in" />
                </button>
                <button
                  [disabled]="!isZoomedIn()"
                  type="button"
                  class="btn btn-icon btn-info-outline"
                  aria-label="resize"
                  (click)="isZoomedIn.set(false)">
                  <cds-icon shape="zoom-out" />
                </button>
              </div>
              <div class="margin-50-b" [class.clr-col-md-6]="!isZoomedIn()" [class.clr-col-12]="isZoomedIn()">
                <div class="clr-row">
                  <!-- * Name Prüfer -->
                  <div class="clr-col-12 clr-col-md-12">
                    <clr-input-container>
                      <label
                        class="clr-required-mark clr-col-12 clr-col-md-5 padding-20-l"
                        for="store.unterschriftPrueferName()">
                        {{ ('Unterschrift' | mrTranslate) + ' ' + ('Prüfer' | mrTranslate) }}
                      </label>
                      <input
                        class="clr-col-12 clr-col-md-7 padding-20-l w-100-p"
                        clrInput
                        formControlName="UnterschriftPrueferName" />
                      <clr-control-error *clrIfError="'required'">
                        {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                      </clr-control-error>
                    </clr-input-container>
                  </div>
                  <!-- * Unterschrift Prüfer -->
                  <div class="clr-col-12 clr-col-md-12 unterschrift" [class.isZoomed]="isZoomedIn()">
                    <div class="clr-col-lg" [class.clr-col-lg-12]="isZoomedIn()">
                      <div class="clr-row">
                        <div class="clr-col margin-6-t" style="display: flex">
                          <button
                            [disabled]="!store.isUnterschriebenPruefer()"
                            type="button"
                            class="btn btn-icon btn-warning-outline"
                            aria-label="clear"
                            (click)="store.setSignature('Pruefer', '')">
                            <cds-icon shape="trash" />
                          </button>
                          <button
                            [disabled]="store.isUnterschriebenPruefer()"
                            type="button"
                            class="btn btn-icon btn-info-outline"
                            aria-label="clear"
                            (click)="openSignPad.set('Pruefer')">
                            <cds-icon shape="pencil" />
                            @if (isZoomedIn()) {
                              <span class="margin-5-l">{{ 'Unterschrift' | mrTranslate }}</span>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="clr-col-lg padding-10-t h-100" [class.clr-col-lg-12]="isZoomedIn()">
                      <img
                        [src]="store.signatures.Pruefer()"
                        class="w-100-p"
                        alt=""
                        width="auto"
                        height="auto"
                        style="max-height: 100%; object-fit: scale-down" />
                    </div>
                  </div>
                </div>
              </div>
              <div [class.clr-col-md-6]="!isZoomedIn()" [class.clr-col-12]="isZoomedIn()">
                <div class="clr-row">
                  <!-- * Name Kunde -->
                  <div class="clr-col-12 clr-col-md-12">
                    <clr-input-container>
                      <label class="clr-required-mark clr-col-12 clr-col-md-5 padding-20-l" for="unterschriftKundeName">
                        {{ ('Unterschrift' | mrTranslate) + ' ' + ('Kunde' | mrTranslate) }}
                      </label>
                      <input
                        class="clr-col-12 clr-col-md-7 padding-20-l w-100-p"
                        clrInput
                        formControlName="UnterschriftKundeName" />
                      <clr-control-error *clrIfError="'required'">
                        {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                      </clr-control-error>
                    </clr-input-container>
                  </div>
                  <!-- * Unterschrift Kunde -->
                  <div class="clr-col-12 clr-col-md-12 unterschrift" [class.isZoomed]="isZoomedIn()">
                    <div class="clr-col-lg" [class.clr-col-lg-12]="isZoomedIn()">
                      <div class="clr-row">
                        <div class="clr-col margin-6-t" style="display: flex">
                          <button
                            [disabled]="!store.isUnterschriebenKunde()"
                            type="button"
                            class="btn btn-icon btn-warning-outline"
                            aria-label="clear"
                            (click)="store.setSignature('Kunde', '')">
                            <cds-icon shape="trash" />
                          </button>
                          <button
                            [disabled]="store.isUnterschriebenKunde()"
                            type="button"
                            class="btn btn-icon btn-info-outline"
                            aria-label="sign"
                            (click)="openSignPad.set('Kunde')">
                            <cds-icon shape="pencil" />
                            @if (isZoomedIn()) {
                              <span class="margin-5-l">{{ 'Unterschrift' | mrTranslate }}</span>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="clr-col-lg padding-10-t h-100" [class.clr-col-lg-12]="isZoomedIn()">
                      <img
                        [src]="store.signatures.Kunde()"
                        class="w-100-p"
                        alt=""
                        width="auto"
                        height="auto"
                        style="max-height: 100%; object-fit: scale-down" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clr-row padding-48-tb padding-24-lr margin-0-lr">
            <div class="clr-col" style="flex-grow: 0; align-self: end">
              <button class="btn btn-primary" type="submit">
                <!-- [disabled]="trial" -->
                {{ 'Abnahmeprotokoll speichern' | mrTranslate }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="clr-col-12 clr-col-lg-5 clr-row nxm padding-24-b">
        <div class="clr-col-12">
          <app-preview-thumbnails
            [drag_drop]="true"
            [acceptTypes]="'image/*, video/*, .pdf'"
            (deleteFile)="deleteDoc($event)"
            (openPdfOverlay)="openPdf($event)"
            [getBigFileFnc]="getLargeFile"
            [highlightFnc]="protokollHighlight"
            [allowCameraVideo]="false" />
        </div>
      </div>
    </div>
  </div>
</div>

@if (openSignPad() !== null; as open) {
  <app-signature-pad-modal [modalOpen]="open" (signImage)="sign($event)" />
}
